import { createContext } from 'react';

const TimbradoContext = createContext();

export default TimbradoContext;
